import { useParams } from 'react-router';
import { useTranslation } from 'react-i18next';
import Link from '../../../components/ui/Link';
import Separator from '../../../components/ui/separator';
import useMemoizedValue from '../../../hooks/useMemoizedValue';

interface TourCardProps {
  TourId?: number;
  name: string;
  duration: string;
  price: number;
  imageUrl: string;
  className: string;
}

function formatPrice(price: number) {
  return price.toLocaleString('id-ID');
}

export default function TourCard({ TourId, name, duration, price, imageUrl, className }: TourCardProps) {
  const { t } = useTranslation();
  const { id } = useParams();
  const formattedPrice = useMemoizedValue(() => formatPrice(price || 0), [formatPrice]);

  const idService = id ? Number(id) : '';

  const tourUrl = `/tour/${TourId}?serviceId=${idService}`;

  return (
    <Link to={tourUrl}>
      <div
        className={`${className} text-start sm:h-72 h-52 shadow-md overflow-hidden bg-cover rounded-lg cursor-pointer hover:drop-shadow-md bg-center transition-all duration-300 ease-in-out`}
        style={{ backgroundImage: `url(${imageUrl || '/assets/no-data-image.svg'})` }}
      >
        <div className="h-full w-full p-1 sm:p-2 bg-gradient-to-t from-primary/80 to-transparent text-white flex justify-end items-center flex-col hover:bg-black/30 transition-all duration-300 ease-in-out">
          <div className="flex flex-col w-full rounded-md drop-shadow-lg sm:gap-2 gap-1 sm:p-3 p-2">
            <div title={name} className="flex flex-col gap-px font-semibold">
              <h1 className="sm:text-2xl text-xl overflow-hidden whitespace-nowrap text-ellipsis">{name}</h1>
              <p className="sm:text-sm text-xs uppercase">{duration}</p>
            </div>
            <Separator />
            <div className="flex flex-col">
              <p className="sm:text-[0.5rem] text-[0.4rem] font-medium">{t('general.startfrom')}</p>
              <div className="sm:text-xl text-base gap-1 flex text-currency font-semibold">
                <p>IDR</p>
                <h1>{formattedPrice}</h1>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Link>
  );
}
